var render = function (_h,_vm) {var _c=_vm._c;return _c('hr',{staticClass:"dropdown-divider"})}
var staticRenderFns = []

export { render, staticRenderFns }